import { render } from "./Mylinks.vue?vue&type=template&id=fa302d6a&scoped=true"
import script from "./Mylinks.vue?vue&type=script&lang=js"
export * from "./Mylinks.vue?vue&type=script&lang=js"

import "./Mylinks.vue?vue&type=style&index=0&id=fa302d6a&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa302d6a"]])

export default __exports__